module.exports = __webpack_public_path__ + "static/img/reference pics_forth tunnel2.c68a065f.jpg";